import { useExperimentBucket } from '@carvana/experiment';

import useWindowLoaded from '../hooks/useWindowLoaded';
import { clientSideUserIdExperiments } from './experiments';
import type { Experiments } from './experiments';

const useIsInExperiment = (name: keyof Experiments, bucket: string = 'experiment') => {
  const assignedBucket = useExperimentBucket(name);
  const isWindowLoaded = useWindowLoaded();

  return clientSideUserIdExperiments[name] && !isWindowLoaded ? false : assignedBucket === bucket;
};

export const useGetExperimentBucket = (name: keyof Experiments) => {
  const assignedBucket = useExperimentBucket(name);
  const isWindowLoaded = useWindowLoaded();

  return clientSideUserIdExperiments[name] && !isWindowLoaded ? 'control' : assignedBucket;
};

export default useIsInExperiment;
